<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-date-picker placeholder="Başlangıç Tarihi" v-on:input="setEndDate" v-model="value.StartDate"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bitiş Tarihi</label>
            <v-date-picker placeholder="Bitiş Tarihi" disabled v-model="value.EndDate"></v-date-picker>
        </div>
        <div class="col-12">
            <v-file-uploader :accept="['xlsx','png','jpg','doc','docx','xls','pdf','jpeg','txt']" :value="value" value-parameter="File"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import moment from 'moment'

export default{
    components:{
        VFileUploader
    },
    props:{
        value:Object
    },
    methods:{
        setEndDate(){
            if(this.value.StartDate){
                this.value.EndDate = moment(this.value.StartDate,'YYYY-MM-DD').add('years',5 || 0).format('YYYY-MM-DD')
            }else{
                this.value.EndDate = null
            }
        }
    },
}
</script>